import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import _ from 'lodash';
import { UtilsService } from '../../../../services/utils.service';
import { TranslateService } from '@ngx-translate/core';
export interface Model {
    title: string;
    data: string;
}

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css', '../../myreports.component.css']
})
export class UserComponent extends DialogComponent<Model, any>
    implements OnInit {
    title: string;
    data: any;
    users: any = [];
    listItem: any = [];
    totalUsers: number = 0;
    count: number = 0;
    currentUser: any;
    ruid: string;
    mutatedUsers: Array<any>;
    columns = [
        {
            name: 'user',
            desc: this.translate.instant('reports.user.user'),
            subName: 'workstation',
            tooltip: '',
            sort: 'asc',
            isCurrent: false
        },
        {
            name: 'sessions',
            desc: this.translate.instant('reports.user.session'),
            tooltip: this.translate.instant('reports.user.sessionTooltip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.numberStringTableSorterFactory
        },
        {
            name: 'duration',
            desc: this.translate.instant('reports.user.total'),
            tooltip: this.translate.instant('reports.user.totalTooltip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.durationTableSorterFactory
        },
        {
            name: 'averageSession',
            desc: this.translate.instant('reports.user.avg'),
            tooltip: this.translate.instant('reports.user.avgTooltip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.durationTableSorterFactory
        },
        {
            name: 'denials',
            desc: this.translate.instant('reports.user.denials'),
            tooltip: this.translate.instant('reports.user.denailsTooltip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.numberStringTableSorterFactory
        },
        {
            name: 'denialRate',
            desc: this.translate.instant('reports.user.denialRate'),
            tooltip: this.translate.instant('reports.user.denailRateTootlip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.numberStringTableSorterFactory
        }
    ];

    limitedColumns = [
        this.columns[0],
        this.columns[1],
        this.columns[2],
        this.columns[4]
    ];

    constructor(
        dialogService: DialogService,
        private utilService: UtilsService,
        private translate: TranslateService
    ) {
        super(dialogService);
    }
    
  trackBy(index, item) {
    if(!item) {
        return null;
    }
    return index;
  }

  ngOnInit() {
    this.users = this.data.users;
    //this.mutatedUsers = mutateDataSet(this.data.users.slice());
    this.totalUsers = this.data.totalUsers;
    this.count = this.data.count;
    this.currentUser = this.data.currentUser;
    this.ruid = this.data.ruid;
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

    sortCols(name) {
        const column = _.find(this.columns, {name: name});
        _.each(this.columns, function (column) {
            column.isCurrent = false;
        });
        column.isCurrent = true;

        const sorter = column.sorter ? column.sorter(name) : name;
        const order = column.sort;

        this.users = _.orderBy(this.users, sorter, order);

        if(this.fullReport()) {
            let subsorter = sorter;
            if(column.subName) {
                subsorter = column.sorter ? column.sorter(column.subName) : column.subName;
            }
            _.each(this.users, function (user) {
                if(user.workstations.length > 1){
                    user.workstations = _.orderBy(user.workstations, sorter, order);
                }
            });
        }

        //this.mutatedUsers = mutateDataSet(this.users.slice());

        if (order === 'asc') {
            column.sort = 'desc';
        } else {
            column.sort = 'asc';
        }


    }

    fullReport(): boolean {
        return (this.currentUser && this.currentUser.paid) || this.ruid == 'demo';
    }

    sortingStyle(column){
        return {'sorting-up': column.isCurrent && column.sort === 'asc', 'sorting-down': column.isCurrent && column.sort === 'desc'}
    }

}

function mutateDataSet(users) {
    for(let i = 0; i < users.length; i++) {
      if(Array.isArray(users[i].workstations) && users[i].workstations.length > 1) {
        let elementsInserted = 0;
        users[i].workstations.forEach((element2, i2) => {
          if(i2 > 0) {
            // console.log('iterate')
            element2.isChild = true;
            // console.log(element2)
            users.splice(i + i2, 0, element2)
            
            elementsInserted++;
          }
        });
        i = i + elementsInserted;
      }
    }
    return users;
  }



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/users/users.component.ts